import { useState, type FormEvent } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from '../auth/AuthProvider'
import CampoSenha from '../componentes/CampoSenha'
import CartaoErro from '../componentes/CartaoErro'

export default function Cadastro() {
  const { cadastrar } = useAuth()
  const navegar = useNavigate()
  const [nome, setNome] = useState('')
  const [email, setEmail] = useState('')
  const [senha, setSenha] = useState('')
  const [erro, setErro] = useState<string | null>(null)
  const [enviando, setEnviando] = useState(false)

  async function aoEnviar(e: FormEvent) {
    e.preventDefault()
    setEnviando(true)
    setErro(null)
    const mensagem = await cadastrar(nome, email, senha)
    setEnviando(false)
    if (mensagem) setErro(mensagem)
    else navegar('/perfil?inicio=1')
  }

  return (
    <main className="min-h-screen flex items-center justify-center bg-slate-100 p-4">
      <form onSubmit={aoEnviar} className="w-full max-w-sm bg-white rounded-xl shadow-sm p-6 space-y-4">
        <h1 className="text-xl font-bold text-slate-800">Criar conta</h1>
        <div>
          <label htmlFor="nome" className="block text-sm text-slate-600 mb-1">Nome</label>
          <input
            id="nome" type="text" required autoComplete="name"
            value={nome} onChange={(e) => setNome(e.target.value)}
            className="w-full border border-slate-300 rounded-lg px-3 py-2"
          />
        </div>
        <div>
          <label htmlFor="email" className="block text-sm text-slate-600 mb-1">E-mail</label>
          <input
            id="email" type="email" required autoComplete="email"
            value={email} onChange={(e) => setEmail(e.target.value)}
            className="w-full border border-slate-300 rounded-lg px-3 py-2"
          />
        </div>
        <div>
          <CampoSenha
            id="senha"
            rotulo="Senha"
            valor={senha}
            aoMudar={setSenha}
            autoComplete="new-password"
            minLength={8}
          />
          <p className="text-xs text-slate-400 mt-1">Mínimo de 8 caracteres.</p>
        </div>
        {erro && <CartaoErro titulo="Não foi possível criar a conta">{erro}</CartaoErro>}
        <button
          type="submit" disabled={enviando}
          className="w-full bg-teal-700 text-white rounded-lg py-2 font-medium disabled:opacity-50"
        >
          {enviando ? 'Criando…' : 'Criar conta'}
        </button>
        <p className="text-sm text-slate-600">
          Já tem conta? <Link to="/login" className="text-teal-700 underline">Entrar</Link>
        </p>
      </form>
    </main>
  )
}
